import { render, staticRenderFns } from "./checkout-contact-data.vue?vue&type=template&id=716ed99a&"
import script from "./checkout-contact-data.vue?vue&type=script&lang=js&"
export * from "./checkout-contact-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports